import $x from '@/utils/$x';

/**
 * 点评调度-分页查询
 * @param {*} params
 * @returns
 */
export async function remarkSchedulePageList(params) {
  return $x.post('/coach/admin/remarkSchedulePageList', params);
}

/**
 * 能不能吃-分页查询
 * @param {*} params
 * @returns
 */
export async function pageFoodAnalysis(params) {
  return $x.post('/consumer/pageFoodAnalysis', params);
}
/**
 * 删除
 * @param {*} params
 * @returns
 */
export async function remarkScheduleDelete(params) {
  return $x.post('/coach/admin/remarkScheduleDelete', params);
}


/**
 * 点评调度-来源渠道下拉框
 * @param {*} params
 * @returns
 */
export async function channelDropDown(params) {
  return $x.post('/coach/admin/channelDropDown', params);
}

/**
 * 点评调度-选择调度教练分页列表
 * @param {*} params
 * @returns
 */
export async function scheduleCoachPageList(params) {
  return $x.post('/coach/admin/scheduleCoachPageList', params);
}

/**
 * 点评调度-新增
 * @param {*} params
 * @returns
 */
export async function remarkScheduleAdd(params) {
  return $x.post('/coach/admin/remarkScheduleAdd', params);
}

/**
 * 点评调度-更新
 * @param {*} params
 * @returns
 */
export async function remarkScheduleUpdate(params) {
  return $x.post('/coach/admin/remarkScheduleUpdate', params);
}

/**
 * 点评调度-详情查询
 * @param {*} params
 * @returns
 */
export async function remarkScheduleGet(params) {
  return $x.post('/coach/admin/remarkScheduleGet', params);
}

/**
 * 点评详情
 * @param {*} params
 * @returns
 */
export async function remarkDetail(params) {
  return $x.post('/ptrainer/class/homework/remarkDetail', params);
}

/**
 * 点评工单分页查询
 * @param {*} params
 * @returns
 */
export async function homeworkPageList(params) {
  return $x.post('/ptrainer/class/homework/pageList', params);
}



